import { render } from "./EditableProfilePicture.vue?vue&type=template&id=006f526c&scoped=true"
import script from "./EditableProfilePicture.vue?vue&type=script&lang=js"
export * from "./EditableProfilePicture.vue?vue&type=script&lang=js"

import "./EditableProfilePicture.vue?vue&type=style&index=0&id=006f526c&lang=css"
import "./EditableProfilePicture.vue?vue&type=style&index=1&id=006f526c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006f526c"]])

export default __exports__